import styled from 'styled-components'

export const Container = styled.div`
  display: grid;
  gap: 24px;
  margin-top: 24px;
`
